// src/data/messages.ts

/**
 * 📚 Категории фактов о ретиноле
 */
export type RetinolFactCategory = 'practice' | 'science' | 'support';

export interface RetinolFact {
  text: string;
  category: RetinolFactCategory;
}

/**
 * 🏷️ Названия категорий для отображения
 */
export const FACT_CATEGORY_LABELS: Record<RetinolFactCategory, string> = {
  practice: 'Практическая польза',
  science: 'Научный факт',
  support: 'Забота о себе',
};

/**
 * 📚 Интересные факты о ретиноле (сбалансированная коллекция)
 */
export const RETINOL_FACTS: RetinolFact[] =[
  // === ПРАКТИЧЕСКАЯ ПОЛЬЗА (8 фактов) ===
  {
    text: 'Ретинол — один из самых изученных компонентов в уходе за кожей, его эффективность подтверждена годами исследований.',
    category: 'practice',
  },
  {
    text: 'Он помогает коже обновляться быстрее — кожа становится более гладкой и ровной, и вы это замечаете.',
    category: 'practice',
  },
  {
    text: 'Ретинол поддерживает плотность и упругость кожи, стимулируя производство коллагена — того белка, который делает кожу «заполненной».',
    category: 'practice',
  },
  {
    text: 'При регулярном использовании ретинол помогает поддерживать чистоту пор и снижать риск новых несовершенств.',
    category: 'practice',
  },
  {
    text: 'Первые результаты обычно заметны через 4–8 недель регулярного применения — это нормальная скорость восстановления.',
    category: 'practice',
  },
  {
    text: 'Ретинол бывает разной силы: можно начинать с мягких форм и постепенно переходить к более интенсивным, чтобы кожа привыкла.',
    category: 'practice',
  },
  {
    text: 'Ретинол отлично сочетается с увлажняющими средствами: вместе они делают кожу мягкой, гладкой и сияющей.',
    category: 'practice',
  },
  {
    text: 'Днём важно использовать SPF — солнцезащита усиливает пользу ретинола и помогает сохранять ровный тон кожи.',
    category: 'practice',
  },

  // === НАУЧНЫЕ ФАКТЫ (4 факта) ===
  {
    text: 'В 1931 году швейцарский химик Пауль Каррер описал химическую структуру витамина A — это открыло путь к созданию современных ретиноидов.',
    category: 'science',
  },
  {
    text: 'Ретинол был открыт в 1913 году двумя независимыми группами учёных из Йельского и Висконсинского университетов.',
    category: 'science',
  },
  {
    text: 'В 1947 году осуществлён первый промышленный синтез ретинола — важный шаг, который сделал ингредиент доступным для массового применения.',
    category: 'science',
  },
  {
    text: 'Сегодня ретинол — один из редких ингредиентов, чей путь от науки до ежедневного ухода за кожей прослеживается почти целый век.',
    category: 'science',
  },

  // === ЭМОЦИОНАЛЬНАЯ ПОДДЕРЖКА (3 факта) ===
  {
    text: 'Ретинол работает ночью: пока вы спите, кожа обновляется, а утром выглядит более свежей.',
    category: 'support',
  },
  {
    text: 'Регулярность — вот что даёт эффект: кожа отражает ту заботу, которую вы ей уделяете.',
    category: 'support',
  },
  {
    text: 'Уход с ретинолом — это не просто средство, а часть заботы о себе и о том, как вы чувствуете свою кожу.',
    category: 'support',
  },
];

/**
 * ✅ Позитивные сообщения при отметке применения
 */
export const POSITIVE_MESSAGES =[
  'Ура! Так держать! 💪',
  'Отлично! Ваша кожа скажет спасибо! ✨',
  'Великолепно! Регулярность — ключ к успеху! 🌟',
  'Браво! Вы на правильном пути! 🎯',
  'Супер! Продолжайте в том же духе! 🚀',
];

/**
 * 💬 Мотивационные сообщения при отказе
 */
export const MOTIVATIONAL_MESSAGES =[
  'Не забудьте нанести ретинол сегодня вечером! 🌙',
  'Ваша кожа ждёт заботы! Применить ретинол? 💚',
  'Всего 2 минуты для красоты кожи! 🧴',
  'Маленький шаг сегодня — большие результаты завтра! ✨',
  'Давайте не пропустим сегодняшний день! 💄',
];